"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissionDocument = void 0;
const base_model_1 = require("../base-model");
const mission_document_schema_1 = require("./mission-document.schema");
class MissionDocument extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {
            isLocked: false,
        };
    }
    getSchema() {
        return mission_document_schema_1.missionDocumentSchema;
    }
}
exports.MissionDocument = MissionDocument;
